<script setup lang="ts">
import VModal from '@shared/component/VModal/VModal.vue';
import VInput from '@shared/form/VInput/VInput.vue';
import FieldRowGroup from '@shared/form/FieldRowV2/FieldRowGroup.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { ref, watch } from 'vue';
import { LicensePlate } from '@license-plate/licensePlate';
import { type SearchParams } from './types';

const emit = defineEmits<{
  search: [SearchParams];
}>();

const isOpen = defineModel<boolean>('isOpen');

const state = ref<SearchParams>({});

defineExpose({
  reset: () => (state.value = {}),
});

function onSearch() {
  isOpen.value = false;

  emit('search', {
    ...state.value,
  });
}

watch(
  () => state.value.kenteken,
  (val) => {
    const licensePlate = new LicensePlate(val ?? '');
    state.value.kenteken = licensePlate.pretty();
  },
);

watch(
  () => state.value.postcode,
  (val) => {
    if (!val || val.length < 6 || val.includes(' ')) {
      return;
    }

    state.value.postcode = `${val.slice(0, 4)} ${val.slice(4).toUpperCase()}`;
  },
);
</script>

<template>
  <VModal
    invert-header
    :is-active="isOpen"
    @confirm-action="onSearch"
    @close-modal="isOpen = false"
    title="Uitgebreid zoeken"
    confirm-button-text="Zoeken"
    deny-button-text=""
  >
    <FieldRowGroup :gap="2">
      <FieldRowV2 label-for="postcode" label="Postcode">
        <VInput id="postcode" type="text" :max-length="7" v-model="state.postcode" />
      </FieldRowV2>
      <FieldRowV2 label-for="email" label="E-mailadres">
        <VInput id="email" type="text" :max-length="64" v-model="state.email" />
      </FieldRowV2>
      <FieldRowV2 label-for="contactpersoon" label="Contactpersoon">
        <VInput id="contactpersoon" type="text" :max-length="35" v-model="state.contactpersoon" />
      </FieldRowV2>
      <FieldRowV2 label-for="polisnummer" label="Polisnummer">
        <VInput id="polisnummer" type="text" :max-length="20" v-model="state.polisnummer" />
      </FieldRowV2>
      <FieldRowV2 label-for="kenteken" label="Kenteken">
        <VInput id="kenteken" type="text" :max-length="8" v-model="state.kenteken" />
      </FieldRowV2>
      <FieldRowV2 label-for="factuurnummer" label="Factuurnummer">
        <VInput id="factuurnummer" type="text" :max-length="10" v-model="state.factuurnummer" />
      </FieldRowV2>
      <FieldRowV2 label-for="schadenummer" label="Schadenummer">
        <VInput id="schadenummer" type="text" :max-length="15" v-model="state.schadenummer" />
      </FieldRowV2>
      <FieldRowV2 label-for="iban" label="IBAN">
        <VInput id="iban" type="text" :max-length="50" v-model="state.iban" />
      </FieldRowV2>
      <FieldRowV2 label-for="kvk-nummer" label="KVK-nummer">
        <VInput id="kvk-nummer" type="text" :max-length="50" v-model="state.kvknummer" />
      </FieldRowV2>
    </FieldRowGroup>
  </VModal>
</template>
